export const CACHE_LENDER_ITEM = 'CACHE_LENDER_ITEM';

export const FETCH_LENDER_ADDRESS_REQUEST = 'FETCH_LENDER_ADDRESS_REQUEST';
export const FETCH_LENDER_ADDRESS_SUCCESS = 'FETCH_LENDER_ADDRESS_SUCCESS';
export const FETCH_LENDER_ADDRESS_FAILURE = 'FETCH_LENDER_ADDRESS_FAILURE';
export const CLEAR_LENDER_ADDRESS_ERROR = 'CLEAR_LENDER_ADDRESS_ERROR';

export const CACHE_LENDER_ADDRESS_EDIT = 'CACHE_LENDER_ADDRESS_EDIT';
